import React, { useEffect, useState, useCallback, useContext } from "react";
import {
	Container,
	Image,
	Row,
	Col,
	Card,
	Accordion,
	Form,
	Button,
	CloseButton,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import { useParams } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../context/appContext";
import InputFileWrapper from "../InputFileWrapper";
import { SESSION_STORAGE_KEY } from "../../utils/constants";

const QUOTE_REQUEST_LIST_API_URL =
	"https://sit48d9es3.execute-api.us-east-1.amazonaws.com/v1/orderBakeries-dev";
const CONVERSATION_API_URL =
	"https://be08zhezjc.execute-api.us-east-1.amazonaws.com/v1/cakeryAppMessaging1745038939";

const tierServings = {
  14: 78,
  12: 56,
  10: 38,
  8: 24,
  6: 12,
  4: 8,
};

const tierConfigs = {
  6: [14, 12, 10, 8, 6, 4],
  5: [14, 12, 10, 8, 6],
  4: [12, 10, 8, 6],
  3: [10, 8, 6],
  2: [8, 6],
  1: [8],
};

const CustomerQuoteRequestDetail = () => {
	const navigate = useNavigate();
	const { id, bakeryName } = useParams();
	const { setGlobalLoading, userSub } = useContext(AppContext);
	const customerTempEmail = localStorage.getItem(SESSION_STORAGE_KEY.CAKE_APP_TEMP_EMAIL) || "";

	const [isSubmitting, setIsSubmitting] = useState(false);

	const [bakeryPrettyName, setBakeryNamePretty] = useState("");
	const [tierOptions, setTierOptions] = useState([]);
	const [numTiers, setNumTiers] = useState(1);
	const [tierShapeOptions, setTierShapeOptions] = useState([]);
	const [tierShape, setTierShape] = useState("round");
	const [cakeFlavors, setCakeFlavors] = useState({});
	const [icingFlavors, setIcingFlavors] = useState({});
	const [fillingFlavors, setFillingFlavors] = useState({});
	const [cakeFlavorOptions, setCakeFlavorOptions] = useState([]);
	const [icingFlavorOptions, setIcingFlavorOptions] = useState([]);
	const [fillingFlavorOptions, setFillingFlavorOptions] = useState([]);
	const [availableDecorations, setAvailableDecorations] = useState([]);
	const [availableDietaryRestrictions, setAvailableDietaryRestrictions] =
		useState([]);
	const [selectedDietaryRestrictions, setSelectedDietaryRestrictions] = useState(
		[],
	);
	const [decorations, setDecorations] = useState([]);
	const [designNotes, setDesignNotes] = useState("");
	const [bakerPrice, setBakerPrice] = useState(null);
	const [refCode, setRefcode] = useState("");
	const [tranDate, setTranDate] = useState("");
	const [chatMessage, setChatMessage] = useState("");
	const [conversation, setConversation] = useState([
		// {
		// 	userType: "Customer",
		// 	message: "Can you add a bow?",
		// 	createdAt: "2025-04-17 15:49:03",
		// },
	]);

	const [samplePhoto6Url, setSamplePhoto6Url] = useState(null);
	const [samplePhoto6File, setSamplePhoto6File] = useState(null);
	const [isSamplePhoto6FileChanged, setIsSamplePhoto6FileChanged] =
		useState(false);

	const [samplePhoto7Url, setSamplePhoto7Url] = useState(null);
	const [samplePhoto7File, setSamplePhoto7File] = useState(null);
	const [isSamplePhoto7FileChanged, setIsSamplePhoto7FileChanged] =
		useState(false);

	const [bakeryLogoUrl, setBakeryLogoUrl] = useState(null);

	const fetchConversation = useCallback(async () => {
		if (!userSub && !customerTempEmail) {
			return;
		}
		
		try {
			setGlobalLoading(true);

			let url = "";
			if (userSub) {
				url = `${CONVERSATION_API_URL}?userSub=${userSub}&bakery=${bakeryName}&quoteRequestId=${id}&type=qr`;
			} else {
				url = `${CONVERSATION_API_URL}?bakery=${bakeryName}&guestEmail=${customerTempEmail}&quoteRequestId=${id}&type=qr`;
			}
			const response = await axios.get(url);

			if (
				response.data?.data &&
				Array.isArray(response.data?.data) &&
				response.data?.data?.length > 0
			) {
				setConversation(response.data?.data);

				const conversationSection = document.getElementById("conversation-section");
				conversationSection.lastElementChild.scrollIntoView({ behavior: "smooth" });
			}
		} catch (error) {
			console.error("❌ Error fetching conversation:", error);
		}
	}, [bakeryName, customerTempEmail, id, setGlobalLoading, userSub]);
	
	useEffect(() => {
		fetchConversation();
	}, [fetchConversation]);

	const fetchQuoteRequestDetail = useCallback(async () => {
		if (!userSub && !customerTempEmail) {
			return;
		}
		try {
			setGlobalLoading(true);

			let url = "";
			if (userSub) {
				url = `${QUOTE_REQUEST_LIST_API_URL}?userSub=${userSub}&bakery=${bakeryName}&id=${id}`;
			} else {
				 url = `${QUOTE_REQUEST_LIST_API_URL}?guestEmail=${customerTempEmail}&bakery=${bakeryName}&id=${id}`;
			}
			const response = await axios.get(url);

			if (
				response.data?.data &&
				Array.isArray(response.data?.data) &&
				response.data?.data?.length > 0
			) {
				setNumTiers(response.data?.data[0]?.numTiers);
				setTierShape(response.data?.data[0]?.tierShape);
				setCakeFlavors(response.data?.data[0]?.cakeFlavors || {});
				setIcingFlavors(response.data?.data[0]?.icingFlavors || {});
				setFillingFlavors(response.data?.data[0]?.fillingFlavors || {});
				setDesignNotes(response.data?.data[0]?.designNotes);
				setBakerPrice(response.data?.data[0]?.bakerPrice);
				setRefcode(response.data?.data[0]?.refCode);
				setTranDate(response.data?.data[0]?.createdAt);
				setSamplePhoto6Url(response.data?.data[0]?.samplePhoto6Url);
				setSamplePhoto7Url(response.data?.data[0]?.samplePhoto7Url);
				setGlobalLoading(false);
			}
			setGlobalLoading(false);
		} catch (error) {
			console.error("❌ Error fetching bakeries:", error);
		}
	}, [bakeryName, customerTempEmail, id, setGlobalLoading, userSub]);

	useEffect(() => {
		fetchQuoteRequestDetail();
	}, [fetchQuoteRequestDetail]);

	const getBakeryStores = useCallback(async () => {
		try {
			setGlobalLoading(true);

			const response = await axios.get(
				`https://lucvle8pqe.execute-api.us-east-1.amazonaws.com/v1/getBakeries-dev?urlPathName=${bakeryName}`,
			);
			if (response?.data?.bakeryStores?.length > 0) {
				const bakery = response.data.bakeryStores[0];

				setBakeryNamePretty(bakery.bakeryName);
				setTierOptions(bakery.selectedTiers);
				setTierShapeOptions(bakery.selectedShapes);
				setCakeFlavorOptions(bakery.cakeFlavors);
				setIcingFlavorOptions(bakery.icingFlavors);
				setFillingFlavorOptions(bakery.fillingFlavors);
				setAvailableDecorations(bakery.designOptions || []);
				setAvailableDietaryRestrictions(bakery.dietaryRestrictions || []);

				if (response?.data?.bakeryStores?.[0]?.bakeryLogoUrl) {
					setBakeryLogoUrl(response?.data?.bakeryStores?.[0]?.bakeryLogoUrl);
				}
			}
		} catch (error) {
			console.error("Error fetching bakery data:", error);
		}
	}, [bakeryName, setGlobalLoading]);

	useEffect(() => {
		getBakeryStores();
	}, [getBakeryStores]);

	const handleCakeFlavorChange = (tier, flavor) => {
		setCakeFlavors((prev) => ({ ...prev, [tier]: flavor }));
	};

	const handleIcingFlavorChange = (tier, flavor) => {
		setIcingFlavors((prev) => ({ ...prev, [tier]: flavor }));
	};

	const handleFillingFlavorChange = (tier, flavor) => {
		setFillingFlavors((prev) => ({ ...prev, [tier]: flavor }));
	};

	const handleUpdateQuote = async (params) => {
		if (!userSub) {
			alert(`Please login with email "${customerTempEmail}" to continue`);
			navigate("/login");
			return;
		}

		try {
			setGlobalLoading(true);
			setIsSubmitting(true);

			let samplePhoto6Filename = "";
			if (samplePhoto6Url) {
				const ext = samplePhoto6File?.type?.split("/")[1];
				const response = await axios.get(
					`https://gvw12pg013.execute-api.us-east-1.amazonaws.com/v1/uploadFile-dev?fileType=${bakeryName}_quote_request_sample_photo1&ext=${ext}`,
				);
				samplePhoto6Filename = response?.data?.filename;
				const samplePhoto6UploadUrl = response?.data?.uploadUrl;
				await axios.put(samplePhoto6UploadUrl, samplePhoto6File);
			}

			let samplePhoto7Filename = "";
			if (samplePhoto7Url) {
				const ext = samplePhoto7File?.type?.split("/")[1];
				const response = await axios.get(
					`https://gvw12pg013.execute-api.us-east-1.amazonaws.com/v1/uploadFile-dev?fileType=${bakeryName}_quote_request_sample_photo1&ext=${ext}`,
				);
				samplePhoto7Filename = response?.data?.filename;
				const samplePhoto7UploadUrl = response?.data?.uploadUrl;
				await axios.put(samplePhoto7UploadUrl, samplePhoto7File);
			}

			const payload = {
				id,
				...(userSub && { userSub }),
				bakery: bakeryName,
				numTiers,
				tierShape,
				cakeFlavors,
				icingFlavors,
				decorations,
				dietaryRestrictions: selectedDietaryRestrictions,
				designNotes,
				...(isSamplePhoto6FileChanged &&
					samplePhoto6Filename && { samplePhoto6Filename }),
				...(isSamplePhoto7FileChanged &&
					samplePhoto7Filename && { samplePhoto7Filename }),
			};

			const response = await axios.patch(QUOTE_REQUEST_LIST_API_URL, payload, {
				headers: { "Content-Type": "application/json" },
			});

			alert(response?.data?.message);
			setGlobalLoading(false);
			setIsSubmitting(false);
		} catch (error) {
			console.error("Error submitting data:", error);
			alert("There was an error submitting your inquiry.");
			setGlobalLoading(false);
			setIsSubmitting(false);
		}
	};

	const handleClickApprove = async () => {
		if (!userSub) {
			alert(`Please login with email "${customerTempEmail}" to continue`);
			navigate("/login");
			return;
		}
	}

	const getTotalServings = () => {
		const config = tierConfigs[parseInt(numTiers)];
		if (!config) return 0;
		return config.reduce((total, size) => total + (tierServings[size] || 0), 0);
	};

	const handleClickSend = async () => {
		if (!userSub) {
			alert(`Please login with email "${customerTempEmail}" to continue`);
			navigate("/login");
			return;
		}
		
		const tempMessage = chatMessage;
		setConversation((prev) => [
			...prev,
			{
				userType: "Customer",
				createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
				message: tempMessage,
			},
		]);
		setChatMessage("");

		setTimeout(() => {
			const conversationSection = document.getElementById("conversation-section");
			conversationSection.lastElementChild.scrollIntoView({ behavior: "smooth" });
		}, 100);

		try {
			const payload = {
				type: "qr",
				quoteRequestId: id,
				userSub,
				userType: "Customer",
				bakery: bakeryName,
				message: tempMessage,
			};

			await axios.post(CONVERSATION_API_URL, payload, {
				headers: { "Content-Type": "application/json" },
			});
		} catch (error) {
			console.log(error)
		}
	};

	if (!userSub && !customerTempEmail) {
		return (
			<div className="text-center mt-5 pb-5">
				<h4
					style={{
						color: "#FEA2C2",
					}}>
					No quote request found
				</h4>
			</div>
		);
	}

	return (
		<Container className="py-5">
			<div className="text-center mb-3">
				{bakeryLogoUrl && (
					<Image
						src={bakeryLogoUrl}
						alt="Bakery Logo"
						style={{
							maxHeight: "80px",
							objectFit: "contain",
							marginBottom: "6px",
						}}
					/>
				)}
				<h4>{bakeryPrettyName}</h4>
				<h4>Ref Code : {refCode || "-"}</h4>
				<h4>
					Date : {tranDate ? `${moment(tranDate).format("YYYY/MM/DD")}` : "-"}
				</h4>
			</div>

			<Card className="shadow-sm" style={{ borderRadius: "15px" }}>
				<Card.Body style={{ padding: "30px" }}>
					<Row>
						{/* LEFT SIDE - FORM */}
						<Col md={6}>
							<h5>Quote Request Update</h5>
							<Accordion defaultActiveKey="0">
								{/* Tier Preferences */}
								<Accordion.Item eventKey="0">
									<Accordion.Header>Tier Preferences</Accordion.Header>
									<Accordion.Body>
										<Form.Group>
											<Form.Label># of Tiers</Form.Label>
											<Form.Select
												value={numTiers}
												onChange={(e) => setNumTiers(Number(e.target.value))}>
												{[...tierOptions]
													?.sort((a, b) => a - b)
													?.map((tier) => (
														<option key={tier} value={tier}>
															{tier}
														</option>
													))}
											</Form.Select>
										</Form.Group>
										<Form.Group className="mt-3">
											<Form.Label className="fw-bold">Tier Shape</Form.Label>
											<Form.Select
												value={tierShape}
												onChange={(e) => setTierShape(e.target.value)}>
												{tierShapeOptions?.map((shape) => (
													<option key={shape} value={shape}>
														{shape}
													</option>
												))}
											</Form.Select>
										</Form.Group>
									</Accordion.Body>
								</Accordion.Item>

								{/* Cake & Icing Flavors */}
								<Accordion.Item eventKey="1">
									<Accordion.Header>Cake & Icing Flavors</Accordion.Header>
									<Accordion.Body>
										{Array.from({ length: numTiers }, (_, i) => (
											<div key={i} className="mb-3 p-3 border rounded">
												<h5 className="fw-bold">Tier {i + 1}</h5>

												<Form.Group>
													<Form.Label>Cake Flavor</Form.Label>
													<Form.Select
														value={cakeFlavors[i + 1] || ""}
														onChange={(e) => handleCakeFlavorChange(i + 1, e.target.value)}>
														{cakeFlavorOptions?.map((flavor) => (
															<option key={flavor} value={flavor}>
																{flavor}
															</option>
														))}
													</Form.Select>
												</Form.Group>

												<Form.Group>
													<Form.Label>Filling Flavor (Optional)</Form.Label>
													<Form.Select
														value={fillingFlavors[i + 1] || ""}
														onChange={(e) =>
															handleFillingFlavorChange(i + 1, e.target.value)
														}>
														<option value="No ">No Filling</option>
														{fillingFlavorOptions?.map((fillingFlavor) => (
															<option key={fillingFlavor} value={fillingFlavor}>
																{fillingFlavor}
															</option>
														))}
													</Form.Select>
												</Form.Group>

												<Form.Group className="mt-2">
													<Form.Label>Icing Flavor</Form.Label>
													<Form.Select
														value={icingFlavors[i + 1] || ""}
														onChange={(e) => handleIcingFlavorChange(i + 1, e.target.value)}>
														{icingFlavorOptions?.map((flavor) => (
															<option key={flavor} value={flavor}>
																{flavor}
															</option>
														))}
													</Form.Select>
												</Form.Group>

												{/* ✅ "Apply to All" Button - Appears ONLY under Tier 1 */}
												{i === 0 && numTiers > 1 && (
													<Button
														variant="outline-primary"
														className="mt-2"
														onClick={() => {
															const tier1Cake = cakeFlavors[1] || "";
															const tier1Icing = icingFlavors[1] || "";
															const tier1Filling = fillingFlavors[1] || "";

															// Prevent applying empty selections
															if (!tier1Cake || !tier1Icing) {
																alert(
																	"Please select both a cake and icing flavor for Tier 1 first.",
																);
																return;
															}

															// ✅ Ensure React recognizes the state change
															setCakeFlavors((prev) => {
																const updatedCakeFlavors = { ...prev };
																for (let j = 2; j <= numTiers; j++) {
																	updatedCakeFlavors[j] = tier1Cake; // ✅ Update all tiers
																}
																return { ...updatedCakeFlavors }; // ✅ Ensure new object reference
															});

															setIcingFlavors((prev) => {
																const updatedIcingFlavors = { ...prev };
																for (let j = 2; j <= numTiers; j++) {
																	updatedIcingFlavors[j] = tier1Icing; // ✅ Update all tiers
																}
																return { ...updatedIcingFlavors }; // ✅ Ensure new object reference
															});

															setFillingFlavors((prev) => {
																const updatedFillingFlavors = { ...prev };
																for (let j = 2; j <= numTiers; j++) {
																	updatedFillingFlavors[j] = tier1Filling; // ✅ Update all tiers
																}
																return { ...updatedFillingFlavors }; // ✅ Ensure new object reference
															});
														}}>
														Apply Tier 1 Selection to All
													</Button>
												)}
											</div>
										))}
									</Accordion.Body>
								</Accordion.Item>

								{/* Dietary Restrictions */}
								{availableDietaryRestrictions.length > 0 && (
									<Accordion.Item eventKey="2">
										<Accordion.Header>Dietary Restrictions</Accordion.Header>
										<Accordion.Body>
											<Select
												isMulti
												options={availableDietaryRestrictions?.map((option) => ({
													value: option,
													label: option,
												}))}
												value={selectedDietaryRestrictions}
												onChange={setSelectedDietaryRestrictions}
											/>
										</Accordion.Body>
									</Accordion.Item>
								)}

								{/* Decorations */}
								{availableDecorations.length > 0 && (
									<Accordion.Item eventKey="3">
										<Accordion.Header>Decorations</Accordion.Header>
										<Accordion.Body>
											<Select
												isMulti
												options={availableDecorations?.map((option) => ({
													value: option,
													label: option,
												}))}
												value={decorations}
												onChange={setDecorations}
											/>
										</Accordion.Body>
									</Accordion.Item>
								)}
							</Accordion>

							<Form.Group className="mt-3">
								<Form.Label>Design Notes / Additional Requests</Form.Label>
								<Form.Control
									as="textarea"
									rows={3}
									value={designNotes}
									onChange={(e) => setDesignNotes(e.target.value)}
								/>
							</Form.Group>

							<Form.Group className="mt-3 mb-4">
								<Form.Label>Sample Photo(s)</Form.Label>
								<Row>
									<Col style={{ position: "relative" }}>
										{samplePhoto6Url && (
											<CloseButton
												style={{ position: "absolute", left: 230, top: 0 }}
												onClick={() => setSamplePhoto6Url(null)}
											/>
										)}
										{samplePhoto6Url ? (
											<Image
												src={samplePhoto6Url}
												rounded
												style={{ width: "200px", height: "200px" }}
											/>
										) : (
											<InputFileWrapper id="file-1">
												<Form.Control
													id="file-1"
													type="file"
													style={{ display: "none" }}
													onChange={(e) => {
														setSamplePhoto6File(e.target.files[0]);
														setSamplePhoto6Url(URL.createObjectURL(e.target.files[0]));
														setIsSamplePhoto6FileChanged(true);
													}}
												/>
											</InputFileWrapper>
										)}
									</Col>
									<Col style={{ position: "relative" }}>
										{samplePhoto7Url && (
											<CloseButton
												style={{ position: "absolute", left: 230, top: 0 }}
												onClick={() => setSamplePhoto7Url(null)}
											/>
										)}
										{samplePhoto7Url ? (
											<Image
												src={samplePhoto7Url}
												rounded
												style={{ width: "200px", height: "200px" }}
											/>
										) : (
											<InputFileWrapper id="file-2">
												<Form.Control
													id="file-2"
													type="file"
													style={{ display: "none" }}
													onChange={(e) => {
														setSamplePhoto7File(e.target.files[0]);
														setSamplePhoto7Url(URL.createObjectURL(e.target.files[0]));
														setIsSamplePhoto7FileChanged(true);
													}}
												/>
											</InputFileWrapper>
										)}
									</Col>
								</Row>
							</Form.Group>

							<Form.Group className="mt-3">
								<Col
									style={{
										padding: "16px",
										border: "1px solid gray",
										borderRadius: "8px",
									}}>
									<Form.Label>
										<h5>Discussion:</h5>
									</Form.Label>
									<Col
										id="conversation-section"
										className="mb-3"
										style={{
											maxHeight: "100px",
											overflow: "scroll",
										}}>
										{conversation?.map((c, i) => {
											return (
												<div
													key={i.toString()}
													style={{
														display: "flex",
														flexDirection: "row",
														alignItems: "flex-start",
														justifyContent: "flex-start",
													}}>
													<span>{c.userType}</span>
													<span style={{ marginRight: "5px", marginLeft: "5px" }}>
														{moment(c.createdAt).format("M/DD")}
													</span>
													<span>: {c.message}</span>
												</div>
											);
										})}
									</Col>
									<Row>
										<Col xl={10}>
											<Form.Control
												as="textarea"
												placeholder="type your message here"
												rows={1}
												value={chatMessage}
												onChange={(e) => setChatMessage(e.target.value)}
												on
											/>
										</Col>
										<Col xl={2}>
											<Button
												disabled={!chatMessage}
												style={{
													backgroundColor: "#FEA2C2",
													border: "none",
													color: "white",
													fontWeight: "bold",
												}}
												onClick={handleClickSend}>
												Send
											</Button>
										</Col>
									</Row>
								</Col>
							</Form.Group>
						</Col>

						{/* RIGHT SIDE - CAKE IMAGE & SUMMARY */}
						<Col
							md={6}
							style={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "space-between",
							}}>
							<Col className="text-center">
								<img
									src={`/${numTiers}tier_${tierShape.toLowerCase()}.png`}
									alt={`${numTiers} Tier Cake`}
									style={{
										width: "220px", // 👈 shrink this if needed
										height: "auto",
										marginBottom: "16px",
										borderRadius: "10px",
										display: "block",
										marginLeft: "auto",
										marginRight: "auto",
									}}
								/>
								<h4>Price : {bakerPrice ? `$${bakerPrice}` : "N/A"}</h4>
								<h5>{getTotalServings()} Servings</h5>
								{/* Cake & Icing Breakdown */}
								{numTiers > 1 && (
									<div className="mt-4 text-start">
										<h5 className="fw-bold">Cake & Icing Breakdown:</h5>
										<ul className="list-unstyled">
											{Array.from({ length: numTiers }, (_, i) => (
												<li key={i} className="mb-2">
													<strong>Tier {i + 1}:</strong>
													<span className="text-muted">
														{" "}
														{cakeFlavors[i + 1] || "Not selected"} cake
													</span>
													,
													<span className="text-muted">
														{" "}
														{icingFlavors[i + 1] || "Not selected"} icing
													</span>
													,
													<span className="text-muted">
														{" "}
														{fillingFlavors[i + 1] || "Not selected"} filling
													</span>
												</li>
											))}
										</ul>
									</div>
								)}
								{/* Dietary Restrictions */}
								{selectedDietaryRestrictions.length > 0 && (
									<div className="mt-3 text-start">
										<h5 className="fw-bold">Dietary Restrictions:</h5>
										<p className="text-muted">
											{selectedDietaryRestrictions?.map((d) => d.label).join(", ")}
										</p>
									</div>
								)}
								{/* Decorations */}
								{decorations.length > 0 && (
									<div className="mt-3 text-start">
										<h5 className="fw-bold">Extras:</h5>
										<p className="text-muted">
											{decorations?.map((d) => d.label).join(", ")}
										</p>
									</div>
								)}
								{/* Design Notes */}
								{designNotes && (
									<div className="mt-3 text-start">
										<h5 className="fw-bold">Additional Design Notes:</h5>
										<p className="text-muted">{designNotes}</p>
									</div>
								)}
							</Col>

							<Row>
								<Col style={{ textAlign: "right" }}>
									<Button
										onClick={handleUpdateQuote}
										disabled={isSubmitting}
										style={{
											width: "200px",
											height: "80px",
											backgroundColor: "#FEA2C2",
											border: "none",
											color: "white",
											fontWeight: "bold",
											padding: "12px 24px",
											fontSize: "1.1rem",
											borderRadius: "8px",
											boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
											transition: "all 0.3s ease-in-out",
											opacity: isSubmitting ? 0.6 : 1,
											cursor: isSubmitting ? "not-allowed" : "pointer",
										}}>
										{isSubmitting ? "Submitting..." : "🎂 Submit Quote Update"}
									</Button>
								</Col>
								<Col style={{ textAlign: "left" }}>
									<Button
										onClick={handleClickApprove}
										disabled={isSubmitting}
										style={{
											width: "200px",
											height: "80px",
											backgroundColor: "#FEA2C2",
											border: "none",
											color: "white",
											fontWeight: "bold",
											padding: "12px 24px",
											fontSize: "1.1rem",
											borderRadius: "8px",
											boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
											transition: "all 0.3s ease-in-out",
											opacity: isSubmitting ? 0.6 : 1,
											cursor: isSubmitting ? "not-allowed" : "pointer",
										}}>
										{isSubmitting ? "Submitting..." : "Approve Quote"}
									</Button>
								</Col>
							</Row>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</Container>
	);
};

export default CustomerQuoteRequestDetail;